/*
 * Recensioni Google curate a mano (trascritte dalla scheda Google Business).
 * Per aggiornarle: modifica/aggiungi voci qui sotto e aggiorna rating/total.
 * timeAgo è testuale nelle due lingue del sito.
 */

export const GOOGLE_RATING = 4.6;
export const GOOGLE_TOTAL_REVIEWS = 192;
export const GOOGLE_REVIEW_URL = 'https://search.google.com/local/writereview?placeid=ChIJSXLL1ZidhkcRVSk5Xyo6dkE';

const reviews = [
  {
    id: 'luni',
    name: 'Luni N.',
    rating: 5,
    timeAgo: { it: '2 settimane fa', en: '2 weeks ago' },
    text: 'Vado in questo centro da diversi anni e mi trovo sempre benissimo. Sono super gentili, molto professionali e mi rimettono sempre in sesto! Bravi! Continuate così!',
  },
  {
    id: 'gertjan',
    name: 'Gert-jan D.',
    rating: 5,
    timeAgo: { it: '3 mesi fa', en: '3 months ago' },
    text: "Molto proffesionale, ho avuto notevole beneficio dal massaggio terapeutico di Mai, era MOLTO strong ma probabilmente perche l'ho chiesto cosi, volevo sbloccare i miei muscoli per forza, e anche se un trattamento probabilmente non basta, sto molto meglio, grazie",
  },
  {
    id: 'josh',
    name: 'Josh L.',
    rating: 5,
    timeAgo: { it: 'un anno fa', en: '1 year ago' },
    text: 'I would give it 10 stars if I could. We needed a last second message and they let us book within the next hour. Relieved so much stress from traveling nonstop. Very professional, polite, and welcoming. I rarely find a place that can massage deep enough for my muscles, and this place did it. Great masseuses and know exactly what to do. I would definitely go back! Not far from the square at all.',
  },
  {
    id: 'smokinblu',
    name: 'Smokinblu',
    rating: 5,
    timeAgo: { it: '4 anni fa', en: '4 years ago' },
    text: "Miglior massaggi Thai che abbia mai ricevuto senza ombra di dubbio! L'unico che posso considerare pari era in Thailandia. E a dire il vero era meglio di certi che ho fatto pure lì.\n\nSono 3 settimane che vengo 1 volta alla settimana e mi sento rinato!\n\nSe andate al trove siete voi a perderci!\n\nLuogo pulito, ultra rilassante e super professionale, continuate così :)",
  },
  {
    id: 'canaan',
    name: 'Canaan L.',
    rating: 5,
    timeAgo: { it: '5 anni fa', en: '5 years ago' },
    text: "Ho fatto molti massaggi e quindi ho una certa esperienza. Al Maithai, abbiamo avuto due massaggiatrici molto professionali che hanno usato la pressione perfetta. Tutto era anche molto pulito e impeccabile. Un posto di prim'ordine!",
  },
  {
    id: 'david',
    name: 'David S.',
    rating: 5,
    timeAgo: { it: '6 anni fa', en: '6 years ago' },
    text: 'Esperienza favolosa! Posto elegante e molto bene curato. Personale competente, professionale di una gentilezza incredibile! Abbiamo fatto massaggio di coppia: 1 h ora di relax totale. Consiglio con tutto me stesso.',
  },
  {
    id: 'gino',
    name: 'Gino S.',
    rating: 5,
    timeAgo: { it: '6 anni fa', en: '6 years ago' },
    text: "Massaggio tradizionale Thailandese operato da due bravissime massaggiatrice, professionali e gentilissime. Sono stato trattato benissimo dall'accogglienza fino alla fine del massaggio. Sono riuscito a immergermi in un relax totale e tutto il mio corpo è stato rigenerato. Grazie mille, tornerò sicuramente.",
  },
  {
    id: 'roland',
    name: 'Roland M.',
    rating: 5,
    timeAgo: { it: '6 anni fa', en: '6 years ago' },
    text: "Massaggio meraviglioso, personale molto cordiale e atmosfera piacevole e pulita. Parlavano inglese senza problemi. Si sono concentrati sulle mie zone problematiche specifiche e mi hanno persino applicato una crema speciale. Avevo prenotato un'ora, ma ne ho ricevute 75. Lo consiglio assolutamente.",
  },
  {
    id: 'heather',
    name: 'Heather',
    rating: 5,
    timeAgo: { it: '6 anni fa', en: '6 years ago' },
    text: 'Mio marito ed io abbiamo guidato per 8 ore fino a Como, in Italia. Ero molto stanca dopo il viaggio. Ero così contenta di aver trovato la Maithai Thai Massage Spa il giorno dopo. Il personale era molto cordiale e professionale, il posto era pulito e, cosa più importante, il massaggio è stato fantastico. Alla fine sono rimasta per un massaggio di 3 ore e mi sono sentita piena di energia dopo il massaggio. La massaggiatrice Mai massaggia con le mani e con il cuore. Consiglio vivamente questo posto se vi trovate a Como, in Italia. - Heather',
  },
  {
    id: 'ao',
    name: 'A. O.',
    rating: 5,
    timeAgo: { it: '6 anni fa', en: '6 years ago' },
    text: "Felicissimo di aver ritrovato la mia terapista di fiducia, Maya, un sollievo per i miei problemi di rigiditá alla schiena e alle anche.\nAmbiente fantastico, pulitissimo e molto silenzioso, a due passi dal centro; sono stato accolto con garbo, gentilezza e generosi sorrisi, che allietano la giornata.\nAdoro il massaggio thaïlandese, girando per lavoro ho provato tantissimi centri avendo la fortuna di trovare a volte anche professioniste esperte, ma vi assicuro e lo dico conoscendola da anni, che le sue capacitá vanno ben oltre, la sua esperienza é la sua dote, per qualsiasi esigenza, che sia prendere una pausa di relax dopo una giornata faticosa, recuperare velocemente dopo una seduta intensa di sport, o trovare finalmente la pace al dolore che ti affligge da tempo, lei e la sua compagna di lavoro saranno in grado di aiutarvi, ne sono certo!\nProvare per credere ;)",
  },
];

export default reviews;
